"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getInitialContext = () => ({
  appointment: undefined,
  appointmentId: undefined,
  cancelEmail: undefined,
  cancelEmailConsent: false,
  cancelReasonText: '',
  locationId: undefined,
  locations: [],
  providerId: undefined,
  provider: {},
  services: {
    cancelAppointment: () => {
      throw new Error('callback not defined');
    },
    getAppointment: () => {
      throw new Error('callback not defined');
    },
    getProvider: () => {
      throw new Error('callback not defined');
    }
  }
});
var _default = exports.default = getInitialContext;